import React from "react";

import { YesNoChoice } from "@gamedev-web/one-gaming-crm";

import { XboxPlayAnywhereUrl } from "../../constants/urls";
import { useStrings } from "../../localization/localizationHelpers";
import { RadioOptionsField } from "../RadioOptionsField";
import { SectionTitle } from "../SectionTitle";
import { SeparatorBar } from "../SeparatorBar";
import * as styles from "./XboxPlayAnywhereSection.module.css";

type XboxPlayAnywhereSectionProps = Readonly<{
  isSaving: boolean;
}>;

export const XboxPlayAnywhereSection = ({ isSaving }: XboxPlayAnywhereSectionProps) => {
  const [
    title,
    introduction,
    programDescription,
    purchaseDescription,
    benefitsTitle,
    reachMorePlayersTitle,
    reachMorePlayersDescription,
    growEngagementTitle,
    growEngagementDescription,
    increaseAwarenessTitle,
    increaseAwarenessDescription,
    learnMore,
    yesOption,
    noOption,
  ] = useStrings(
    "xboxPlayAnywhereTitle",
    "xboxPlayAnywhereIntroduction",
    "xboxPlayAnywhereProgramDescription",
    "xboxPlayAnywherePurchaseDescription",
    "xboxPlayAnywhereBenefitsTitle",
    "xboxPlayAnywhereReachMorePlayersTitle",
    "xboxPlayAnywhereReachMorePlayersDescription",
    "xboxPlayAnywhereGrowEngagementTitle",
    "xboxPlayAnywhereGrowEngagementDescription",
    "xboxPlayAnywhereIncreaseAwarenessTitle",
    "xboxPlayAnywhereIncreaseAwarenessDescription",
    "xboxPlayAnywhereLearnMore",
    "xboxPlayAnywhereYesOption",
    "xboxPlayAnywhereNoOption"
  );

  return (
    <>
      <section className={styles.playAnywhereSection}>
        <SectionTitle title={title} />
        <div data-play-anywhere-copy>
          <p>{introduction}</p>
          <p>
            {programDescription}
            <br />
            {purchaseDescription}
          </p>
          <h4>{benefitsTitle}</h4>
          <p>
            <strong>{`${reachMorePlayersTitle} –`}</strong>
            <span className={styles.playAnywhereBenefitCopy}>{reachMorePlayersDescription}</span>
          </p>
          <p>
            <strong>{`${growEngagementTitle} –`}</strong>
            <span className={styles.playAnywhereBenefitCopy}>{growEngagementDescription}</span>
          </p>
          <p>
            <strong>{`${increaseAwarenessTitle} –`}</strong>
            <span className={styles.playAnywhereBenefitCopy}>{increaseAwarenessDescription}</span>
          </p>
          <p>
            <a href={XboxPlayAnywhereUrl} target="_blank" rel="noopener noreferrer">
              {`${learnMore} ${title}`}
            </a>
          </p>
        </div>
        <RadioOptionsField
          options={[
            { value: YesNoChoice.yes, label: yesOption },
            { value: YesNoChoice.no, label: noOption },
          ]}
          name="xboxPlayAnywhere"
          title={title}
          listAsColumn={true}
          isRequiredField={true}
          isSaving={isSaving}
        />
      </section>
      <SeparatorBar />
    </>
  );
};
